// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form__title[data-v-2b8540ad] {\n    display: block;\n    margin: 0 0 -8px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
